import Repository from './Repository';

const resource = '/quizzes';

export default {
    get(payload)            {return Repository.get(`${resource}`, payload);},
    getRandomQuestion(id)   {return Repository.get(`${resource}/${id}/random`);},
    getQuiz(id)             {return Repository.get(`${resource}/${id}/quiz`);},
    finish(payload)         {return Repository.post(`${resource}/finish`, payload);},
    answer(payload)         {return Repository.post(`${resource}/answer`, payload);},
    changeQuizStatus(payload) {return Repository.post(`${resource}/changeQuizStatus`, payload);},
}